import events from './events'

export default { events }
